export class Order{
  id:number;
  status_id:number;
  reason_id:number;
  area_id:number;
  user_id:number;
  approver_id:number;
  approve_date:Date;
  receptor_id:number;
  reception_date:Date;
  client_id:number;

  constructor(id,status_id,reason_id,area_id,user_id,approver_id,approve_date,receptor_id,reception_date,client_id){
    this.id = id;
    this.status_id = status_id;
    this.reason_id = reason_id;
    this.area_id = area_id;
    this.user_id = user_id;
    this.approver_id = approver_id;
    this.approve_date = approve_date;
    this.receptor_id = receptor_id;
    this.reception_date = reception_date;
    this.client_id = client_id;
  }

  getJson(){
    let body = `{
                "data": {
                          "type": "orders",
                          "attributes": {
                                        "id": "${this.id}",
                                        "status_id": "${this.status_id}",
                                        "reason_id": "${this.reason_id}",
                                        "client_id": "${this.client_id}"
                                        }
                        }
                }`;
    return body;
  }

  getJsonUpdateStatusToApprovated(){
    let body = `{
      "data":{
        "type":"orders",
        "attributes": {
          "id":"${this.id}",
          "status_id":"2"
        }
      }
    }`;
    return body;
  }

  getJsonUpdateStatusToPreApprovated(){
    let body = `{
      "data":{
        "type":"orders",
        "attributes": {
          "id":"${this.id}",
          "status_id":"5"
        }
      }
    }`;
    return body;
  }

  getJsonUpdateStatusToRevision(){
    let body = `{
      "data":{
        "type":"orders",
        "attributes": {
          "id":"${this.id}",
          "status_id":"4"
        }
      }
    }`;
    return body;
  }

  getJsonUpdateStatusToClosed(){
    let body = `{
      "data":{
        "type":"orders",
        "attributes": {
          "id":"${this.id}",
          "status_id":"3"
        }
      }
    }`;
    return body;
  }

  getJsonCommentaryOrder(message){
    let body = `{
      "data":{
        "attributes":{
          "message":"${message}"
        }
      }
    }`;
    return body;
  }

  getJsonDeleteAllTags(tags:any,id_order:number){
    let coma = ',';
    let body = `{"data":[`;
    let num = 1;
    let num_tags = tags.length;
    for(let tag of tags){
      if(num == num_tags){
        coma = '';
      }
      body += `{"tag_id":"${tag.id}"}${coma}`;
      num++;
    }
    body += `]}`;
    return body;
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/Order.ts